import './App.css';
import Topbar from "./scenes/global/Topbar";// eslint-disable-next-line
// import Sidebar from "./scenes/global/Sidebar";// eslint-disable-next-line
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import {  useState } from 'react';
import About from './scenes/About/About';
import { Footer } from './scenes/Footer/Footer';
import { Route, Routes } from 'react-router-dom';
import { Skill } from './scenes/Skills/Skill';
// import { tokens } from './theme';
import { Projects } from './scenes/Projetcs/Projects';
import { Contact } from './scenes/Contact/Contact';
function App() {
  const [theme, colorMode] = useMode();// eslint-disable-next-line
   const [isSidebar, setIsSidebar] = useState(true);


 
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {/* <Sidebar isSidebar={isSidebar} /> */}
          <main className="content">
            <Topbar setIsSidebar={setIsSidebar} />
            
            <Routes>
              <Route path='/' element={<About></About>} ></Route>
              <Route path='/skill' element={<Skill></Skill>} ></Route>
              <Route path='/Projects' element={<Projects></Projects>} ></Route>
              <Route path='/Contact' element={<Contact></Contact>} ></Route>
            </Routes>
            
            <Footer></Footer>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
